<template lang="pug">
.faq#faq
  .l-container.is-lg.fadeup
    h2
      | FAQ
      span よくあるご質問
    .faq-body
      .faq-list(v-bind:class="{ 'is-active': isFaqShow }")
        .faq-category(v-for="list in getList()" :key="list.id")
          h3(v-if="list.category")
            | {{ list.category }}
          div(v-for="item in list.items" :key="item.id")
            accordion(@faq-open="showMoreFaqByButton")
              template(v-slot:title)
                | {{ item.q }}
              template(v-slot:body)
                .txt(v-html="item.a")
      .faq-more(v-if="!isFaqShow")
        .faq-more-btn.school-btn.is-gray.is-sm(@click="showMoreFaq")
          | よくある質問をもっと見る
</template>

<script>
import Accordion from '~/components/school/Accordion.vue'
export default {
  components: {
    Accordion
  },
  props: {
    current: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isFaqShow: false,
      faq_lists_videographer: [
        {
          id: 1,
          category: 'コンセプト',
          items: [
            {
              id: 1,
              q: 'ビデオグラファーとは何ですか？',
              a:
                '”ビデオグラファー”とは、映像制作においてたった一人、あるいはごく少人数のチームにおいてマルチスキルを活かして制作するクリエイターのことです。企画・構成から撮影、そして編集作業までを同じチームやクリエイターが担当することでクリエイター独自のスタイルを存分に活かすことが出来るほか、予算面でも効率がいいことから昨今ではビデオグラファースタイルでの映像制作が急速に普及しています。'
            },
            {
              id: 2,
              q:
                'ビデオグラファーコースを学ぶと、どのような仕事ができるようになりますか？',
              a:
                'ビデオグラファーコースでは、映像制作に関するあらゆる職域の基本スキルを学ぶことが出来ます。ですから、映像に関する幅広い現場で「広範囲のスキルを持つ即戦力」として働くことが出来ます。<br><br>またご自身でお仕事を受けて制作する案件としては、ワンオペ〜少人数のチームで制作出来る範囲の映像でしたらあらゆるジャンルの映像が制作可能になります。広告映像、企業VP、ドキュメンタリー、ミュージックビデオなどなど、入校を希望される方は「自分は何を作れるようになりたいか」を、受講を通して探して頂くことになります。<br><br>また、卒業後は企業に就職する方だけでなく、映像制作系のフリーランスとして独立される方や、既にご自身で展開している事業に映像制作事業を追加される受講生も多くいらっしゃいます。'
            },
            {
              id: 3,
              q: '映像制作をしたことが無いのですが、受講できますか？',
              a:
                '可能です！初心者でも一から学習を進められるように教材を設計しております。疑問点はメンターに相談可能です。'
            },
            {
              id: 4,
              q:
                '仕事で撮影や編集の経験が既にあるのですが、新たに得られるものはありますか？',
              a:
                '映像業界経験者の方にも、非常にご好評頂いております。受講後のお声としては「これまで不足していた/曖昧だった部分の知識や技術を補完することが出来た」「業務上なんとなく覚えてきたことがどの程度正解なのか、メンターとのやり取りで確かめられた」「これまで仕事に追われてなかなか出来なかった自分の作品作りに挑戦したことで、新たなキャリアの目標が出来た」などといったものがあります。ご参考にしてみてください。'
            }
          ]
        },
        {
          id: 2,
          category: 'カリキュラム内容',
          items: [
            {
              id: 1,
              q: 'それぞれの章ではどのような内容を学習できるのでしょうか？',
              a:
                '各章のタイトルは下記のとおりです。<br><br>0章「イントロ」<br>1章「カメラ操作」<br>2章「撮影方法」<br>3章「撮影基礎」<br>4章「基礎機材」<br>5章「照明」<br>6章「録音」<br>7章「特機」<br>8章「制作業務」※マスタープラン専用<br>9章「カット構成／コンテ」※マスタープラン専用<br>10章「編集」※マスタープラン専用<br>11章「カラコレ／グレーディング」※マスタープラン専用'
            },
            {
              id: 2,
              q: '教材はどのような内容ですか？',
              a:
                'カリキュラムはスライド形式で、オンライン上で閲覧することができます。<br>内容としてはカメラの基本的な扱い方から編集のテクニック、音声収録の方法、照明を組む際の考え方、基本的な機材から特機までのオペレーション方法など、映像制作に関するスキルを一通り網羅したものになっております。<br><br>学習時にはそれらをお手元で読みながら、実際に機材やソフトウェアを触って理解を深めて頂きます。<br>また教材では一つのカリキュラムごとに理解度をチェックするための課題が用意されております。都度課題を行なって、メンターに提出する仕組みです。'
            },
            {
              id: 3,
              q: '授業は行われますか？もしくは、授業の動画等はありますか？',
              a:
                'Vook schoolでは授業や、授業を収録した動画はございません。<br>独自の教材による自主学習と、学習を全面サポートするメンター制度により学習を進めていただきます。画一的な授業よりも受講生一人ひとりのスキルを確実に伸ばすため、Vook schoolではこのような形式を取っております。'
            },
            {
              id: 4,
              q: 'どのようなソフトの使い方を学べますか？',
              a:
                'ビデオグラファーコースの教材では、下記のソフトを使用した制作方法を解説しております。<ul class="list-disc"><li>Adobe Premiere Pro</li><li>DaVinci Resolve</li><li>Adobe After Effects（マスタープランのみ）</li></ul>'
            },
            {
              id: 5,
              q:
                'コースを通じてどのような作品を作れるようになりますか？また、それによってどのような仕事ができるようになりますか？',
              a:
                'お一人〜少人数のチームで制作出来る範囲の映像であれば、あらゆるジャンルの映像制作にチャレンジして頂けます。例を挙げますと広告映像、サービス・商品紹介映像、イベント記録映像、ブライダルムービー、ドキュメンタリー、ミュージックビデオ、ショート・ムービー…などなどです。<br><br>卒業後はフリーランスとしてご自身が得意とする映像の分野で開業する方もいれば、企業に就職して身につけたスキルを活かして働く方も多くいらっしゃいます。<br><br>あくまで傾向ですが、フリーとして開業した方の多くはまずは企業系のサービス・店舗・商品紹介映像や採用映像など、いわゆる企業・事業VP系の映像を手掛ける方が多いです。'
            },
            {
              id: 6,
              q: 'カリキュラムの進行が早ければ早く卒業することもできますか？',
              a:
                '可能です。ビデオグラファーコースの多くのプランは月額制となっておりまして、早いペースで進めていただくほど総額でお支払いいただく金額も少なくなります。（ポートフォリオ支援プランのみ、料金も通学期間も固定）'
            }
          ]
        },
        {
          id: 3,
          category: 'メンター制度',
          items: [
            {
              id: 1,
              q: 'メンターとは何ですか？',
              a:
                'メンターは全員が現役のプロクリエイターで、各々の経験に基づく実践的なアドバイスや、受講生一人ひとりの経験や目標に合わせた細やかな指導を行います。学習やポートフォリオ制作を進めるにあたり、質問や相談を受けたり、提出された課題のフィードバックを行います。<br>日毎に当番が決まっているため、日によって様々なメンターの話を聞くことができます。'
            },
            {
              id: 2,
              q: 'メンターへの相談や課題提出はどうやって行いますか？',
              a: '来校時に直接受け付けております。'
            },
            {
              id: 3,
              q: 'メンターには教材の範囲外の質問や相談もできますか？',
              a:
                '可能です。映像に関連する仕事やキャリア設計など、メンターがそれぞれの経験に基づきアドバイスさせていただきます。'
            }
          ]
        },
        {
          id: 4,
          category: '学習の進め方',
          items: [
            {
              id: 1,
              q: '地方に住んでいるのですが、受講可能ですか？',
              a:
                '指導のクオリティを担保するために、原則として週2～3回以上の来校を推奨しております。<br>ただし来校いただける頻度やご経験、お持ちの機材等によっては遠方にお住まいでも受講いただける場合がございます。<br>個別相談会はオンラインでも承っておりますので、まずはお気軽にご相談ください！'
            },
            {
              id: 2,
              q: '仕事をしながら受講することは可能ですか？',
              a:
                'もちろん可能です。<br>平日の夕方以降と土祝に開校しているので、学校やお仕事に通いながらの受講にピッタリです。現在のお仕事状況に合わせた学習スケジュールをご提案させていただきます。<br><br><strong>＜渋谷校 開校時間＞</strong><br>平日／17:00～21:00<br>土祝／10:30～19:00<br>定休日／日・月'
            },
            {
              id: 3,
              q:
                '座学部分をできるだけ先へ進めたいと思っています。今見ることのできているもの以降のカリキュラムを閲覧できる状態にしていただけないでしょうか？',
              a:
                'ご事情によっては柔軟に対応可能です。例えばしばらく来校が難しく、かつ中課題の課題チェックも難しい場合には一旦先のカリキュラムをお見せすることがございます。しかし、まだ既存のカリキュラムを復習した方がその方にとって学習効果があると判断した場合には、カリキュラムをお見せしないこともございます。ご了承くださいませ。'
            },
            {
              id: 4,
              q:
                '自分で設定した受講期間内に学習が終わらなかった場合はどうなりますか？',
              a:
                'そのまま予定通りご卒業いただくか、あるいは翌月も延長するかお選びいただくことが可能です。<br>ご卒業の場合は、それまでに履修されたカリキュラムをダウンロードいただけます。延長される場合は、追加分の受講料がかかります。なお、受講期間は最長でも入校から一年間とさせていただいております。'
            },
            {
              id: 5,
              q: '受講期間中、休学は可能ですか？',
              a:
                'マスタープランの場合、在籍期限内(1年間)であれば、柔軟に休学は可能です。<br>マスタープラン以外のプランですと、休学は原則できません。'
            }
          ]
        },
        {
          id: 5,
          category: '就職支援・卒業後',
          items: [
            {
              id: 1,
              q: '卒業後も教材は見られますか？',
              a:
                '教材のダウンロードは可能です。卒業時に学習を進めていただいた章までがダウンロードの対象範囲となります。<br><br>ただ、マスタープランを６ヶ月以上受講された方の場合、進めた範囲とは関係なく、全てのカリキュラムをダウンロードすることが可能です。'
            }
          ]
        },
        {
          id: 6,
          category: 'プランについて',
          items: [
            {
              id: 2,
              q: '受講期間中にプランを変更することは可能ですか？',
              a:
                '翌月分のプランより、プランの変更は可能です。<br>当月分は、予めお申し込みいただいていたプランをご受講いただき、翌月分からプラン変更が適用されます。'
            }
          ]
        },
        {
          id: 7,
          category: '申し込み・入校について',
          items: [
            {
              id: 1,
              q: '入校日はいつですか？',
              a:
                '原則、月初の営業日が入校日です。年末年始の影響で、毎年１月は入校日を変更させていただく場合がございます。'
            },
            {
              id: 3,
              q: '申込期限はいつですか？',
              a:
                '基本的に入校日の１週間前とさせていただいております。「入金が間に合わなさそう」などありましたら、柔軟に対応させていただきますので、お気軽にご相談ください。'
            },
            {
              id: 4,
              q: '支払いはどのような方法でできますか？',
              a: 'クレジットカード支払いにて、お願い申し上げます。'
            },
            {
              id: 5,
              q: '使えるクレジットカードの種類を教えてください。',
              a:
                'Visa、 Mastercard 、 American Express、 JCB、Diners Club、Discoverの６ブランドに対応しています。'
            },
            {
              id: 6,
              q: '分割払いは可能ですか？',
              a:
                '大変申し訳ございません。現状は不可となっております。 ただ、クレジットカードによっては、一括でご決済をいただいた後、ご自身で分割の設定ができるものもございまして、そちらは問題ございません。その際、手数料が発生する場合がございますので、あとから分割ができる機能があるかも含めて、各クレジットカード会社の方へご確認ください。なお、他校様の相場と比較した場合でもカリキュラムに対して適正な価格設定をしておりますので、その点はご安心いただければと思います。'
            },
            {
              id: 7,
              q: '受講料以外に必要な費用はありますか？',
              a:
                '弊社としていただく費用は申込金額以外はございません。 PC・ソフトウェア等はご自身でご用意いただいております。'
            },
            {
              id: 8,
              q: '割引はないですか？',
              a:
                '原則表示されている価格でのご案内となります。キャンペーン等で一時的に価格を変更する場合がございますが、 不定期となりますのでみなさま基本的には定価でお申し込みを頂いております。 決して安い金額ではございませんが、その分、十分なスキルと経験を身に着けて頂けるカリキュラムと体制を整えておりますので、 将来に必ず役立つ投資になると自信を持ってお伝えさせていただきます。'
            },
            {
              id: 9,
              q: '請求書払いは可能ですか？',
              a:
                '法人負担の場合は対応可能です。掛け払いですと、与信審査がございます。'
            }
          ]
        },
        {
          id: 8,
          category: '受講に必要なもの',
          items: [
            {
              id: 1,
              q: '最低限必要なものは何ですか？',
              a:
                '<ul class="list-disc"><li>ノートPC（メモリ16GB以上を推奨）</li><li>ご自宅のインターネット接続環境（来校時には校内の無料Wi-fiをご利用いただけます）</li><li>編集ソフト（Adobe Premiere Pro、DaVinci Resolveのいずれかを推奨。DaVinci Resolveは無償版も可）</li></ul>'
            },
            {
              id: 2,
              q: 'カメラなど撮影機材を持っていないと受講できないのでしょうか？',
              a:
                'パソコンや必要ソフトウェアについては、ご自身でご用意いただきますが、その他機材につきましては、校舎に使用可能な機材がありますのでご安心ください。<br>カメラなど、最終的に、ご購入・レンタルすることになると思いますが、まずは本校を通してご自身に合う機材を探してもらうことをおすすめしております。ぜひメンターへご相談ください。'
            },
            {
              id: 3,
              q: '受講にあたってどのようなスキルが必要ですか？',
              a:
                '映像制作に関するスキルは受講開始後に一から学んでいただけるため、PCの一般的な操作方法を理解していれば問題ありません。'
            }
          ]
        },
        {
          id: 9,
          category: '機材について',
          items: [
            {
              id: 1,
              q: '機材貸し出しのルールはありますか？',
              a:
                '<a href="/terms" target="_blank">こちら</a>の利用規約をご覧ください。詳細は入校後のオリエンテーションでレクチャーいたします。'
            },
            {
              id: 2,
              q: 'スクール内にドローンはありますか？',
              a:
                '申し訳ございません。ドローンに関しては校内に実機はご用意がなく、カリキュラム内ではその利用メリットやカメラワークのパターン、申請の種類や免許などについて座学にて学んでいただくにとどまっております。'
            }
          ]
        },
        {
          id: 10,
          category: 'その他',
          items: [
            {
              id: 1,
              q: '高校生でもVook schoolに入学することは可能でしょうか？',
              a: '高校生であっても保護者様の同意があれば入校可能です。'
            },
            {
              id: 2,
              q: '教育給付金制度は使えますか？',
              a:
                'Vook schoolは教育給付金制度の対象外となっております。ご希望に添えず、大変申し訳ございません。'
            }
          ]
        }
      ],
      faq_lists_motiongraphics: [
        {
          id: 1,
          category: 'コンセプト',
          items: [
            {
              id: 1,
              q: 'モーショングラフィックスとは何ですか？',
              a:
                'デザインされた文字や画などにモーションを加えることで、より伝わりやすくする映像手法です。<br>MV・CM・プロモ－ション動画・商品やサービスの紹介動画など、幅広いジャンルの映像で使われています。'
            },
            {
              id: 2,
              q:
                'モーショングラフィックスを学ぶと、どのような仕事ができるようになりますか？',
              a:
                'モーショングラフィックスを学ぶと、オフライン/オンラインエディター、コンポジター、映像作家などの仕事につながります。'
            },
            {
              id: 3,
              q: '映像制作をしたことが無いのですが、受講できますか？',
              a:
                '可能です！初心者でも一から学習を進められるように教材を設計しております。また疑問点はメンターにチャットや通話で質問可能です。'
            },
            {
              id: 4,
              q:
                '仕事でモーショングラフィックスの経験が既にあるのですが、新たに得られるものはありますか？',
              a:
                '既にお仕事の経験のある方でも、仕事や独学では体系的に学習することが難しいという理由で入校する方は一定の割合でいらっしゃいます。<br>また課題へのフィードバックは個々のレベルに合わせて行いますので、例えば経験者の方に「課題としては合格点ですが、もう一歩この辺りを突き詰めてみましょう」等、より成長していただけるようなアドバイスをさせていただく場合もございます。'
            }
          ]
        },
        {
          id: 2,
          category: 'カリキュラム内容',
          items: [
            {
              id: 1,
              q: 'それぞれの章ではどのような内容を学習できるのでしょうか？',
              a:
                '各章のタイトルは下記のとおりです。<br>2章～7章はテーマに合わせた作品が用意されており、その作品の制作にあたっての考え方やソフトの操作方法等を順に学んでいきます。また企画書・請求書の作成など制作業務についても学習できます。<br><br>1章「モーション入門」<br>2章「インフォグラフィックス」<br>3章「ロゴモーション」<br>4章「架空の15秒CM」<br>5章「ブランディング映像」<br>6章「実写合成」　※マスタープラン専用<br>7章「空間演出」　※マスタープラン専用'
            },
            {
              id: 2,
              q: '教材はどのような内容ですか？',
              a:
                '教材はスライド形式で、オンライン上で閲覧することができます。<br>内容としては画面操作・制作手順のお手本や作り方のコツを解説していますので、それらを読みながらご自身の手元で制作を進めていただくことになります。<br>また教材には理解度をチェックするための課題が多数用意されておりますので、都度制作してメンターに提出しましょう。'
            },
            {
              id: 3,
              q: '授業は行われますか？もしくは、授業の動画等はありますか？',
              a:
                'Vook schoolでは授業や、授業を収録した動画はございません。<br>独自の教材による自主学習と、学習を全面サポートするメンター制度により学習を進めていただきます。画一的な授業よりも受講生一人ひとりのスキルを確実に伸ばすため、Vook schoolではこのような形式を取っております。'
            },
            {
              id: 4,
              q: 'どのようなソフトの使い方を学べますか？',
              a:
                'モーショングラフィックスコースの教材では、下記のソフトを使用した制作方法を解説しております。<br><ul class="list-disc"><li>Adobe After Effects</li><li>Adobe Premiere Pro</li><li>Adobe Illustrator</li><li>Adobe Photoshop</li><li>Red Giant Complete（Ae用プラグイン、マスタープランで使用）</li></ul>'
            },
            {
              id: 5,
              q:
                'コースを通じてどのような作品を作れるようになりますか？また、それによってどのような仕事ができるようになりますか？',
              a:
                'モーショングラフィックスコースで学んだ内容は、MV・CM・プロモ－ション動画・商品やサービスの紹介動画など、幅広いジャンルの映像に活用できます。<br>またモーショングラフィックスを使う仕事としては、オフライン/オンラインエディター、コンポジター、映像作家などがあります。'
            },
            {
              id: 6,
              q: 'カリキュラムの進行が早ければ早く卒業することもできますか？',
              a:
                '可能です。モーショングラフィックスコースの多くのプランは月額制となっておりまして、早いペースで進めていただくほど総額でお支払いいただく金額も少なくなります。'
            }
          ]
        },
        {
          id: 3,
          category: 'メンター制度',
          items: [
            {
              id: 1,
              q: 'メンターとは何ですか？',
              a:
                'メンターは受講生が教材の学習やポートフォリオ制作を進めるにあたり、質問や相談を受けたり、提出された課題のフィードバックを行います。<br>日毎に当番が決まっているため、日によって様々なメンターの話を聞くことができます。<br><br>メンターは全員が現役のプロクリエイターで、各々の経験に基づく実践的なアドバイスや、受講生一人ひとりの経験や目標に合わせた細やかな指導を行います。'
            },
            {
              id: 2,
              q: 'メンターへの相談や課題提出はどうやって行いますか？',
              a:
                'チャットアプリ「Discord」上でメンターとやり取りをしていただきます。<br><br><strong>＜チャットサポート＞</strong><br>チャットで受け付けたご質問は、原則24時間以内（日曜日を除く）に返信いたします。<br><br><strong>＜通話サポート＞</strong><br>週3日(*)実施 / 営業時間　10:00-12:00、13:00-18:00<br>*1) 土・祝日は必ず実施します<br>*2) 平日は特定の曜日ではなく週によって実施曜日が異なります<br>通話サポート日、メンターはDiscord内に常駐しております。<br>年末年始や、そのほか当社の都合により一部変更となる場合があります。'
            },
            {
              id: 3,
              q: 'メンターには教材の範囲外の質問や相談もできますか？',
              a:
                'モーショングラフィックスやそれに関連する仕事・キャリアに関する内容でしたら可能です！メンターがそれぞれの経験に基づきアドバイスさせていただきます。'
            },
            {
              id: 4,
              q:
                'メンターのサポート制度について、どのようなレベル感でサポートを受けられますか？',
              a:
                '現在はメンターが8人在籍しており、それぞれのメンターから、あらゆる目線でアドバイスをしております。<br><br>【アドバイスの内容】<ul class="list-disc"><li>カリキュラム攻略のための手順</li><li>モーショングラフィックスらしい演出方法</li><li>さらにアレンジを加えるための方法論</li><li>After Effectsの技術的な補足</li><li>実際に使用しているプラグインなど</li></ul>上記は一例で、カリキュラムへの質問から、After Effectsの使い方、仕事の悩みなどもお答えしております。<br><br>以下の画像は実際のやりとりを保存したものになります。<ul class="faq-mentor-chat"><li><img src="/images/pages/school/motion-graphics/faq-mentor-chat1.png"></li><li><img src="/images/pages/school/motion-graphics/faq-mentor-chat2.png"></li><li><img src="/images/pages/school/motion-graphics/faq-mentor-chat3.png"></li><li><img src="/images/pages/school/motion-graphics/faq-mentor-chat4.png"></li></ul>'
            }
          ]
        },
        {
          id: 4,
          category: 'Discord',
          items: [
            {
              id: 1,
              q: 'Discordではどのようなことができますか？',
              a:
                'Discordでは、メンターへの課題提出・フィードバック・学習に関する質問や相談等を行うことができます。テキストによるチャットと、音声や画面共有による通話がご利用いただけます。また、受講生同士で交流していただけるチャンネルもございます。<br><br><strong>＜チャットサポート＞</strong><br>チャットで受け付けたご質問は、原則24時間以内（日曜日を除く）に返信いたします。<br><br><strong>＜通話サポート＞</strong><br>週3日(*)実施 / 営業時間　10:00-12:00、13:00-18:00<br>*1) 土・祝日は必ず実施します<br>*2) 平日は特定の曜日ではなく週によって実施曜日が異なります<br>通話サポート日、メンターはDiscord内に常駐しております。<br>年末年始や、そのほか当社の都合により一部変更となる場合があります。'
            },
            {
              id: 2,
              q: 'Discord利用の際、iPhoneのアプリで参加できますか？',
              a:
                'カリキュラムの閲覧方法など、情報はすべてDiscordに集約をしておりますが、Webブラウザで閲覧する形式ですのでURLさえわかれば他端末でも閲覧できます。<br>ただ、根本的な部分として、スマホからDiscordを閲覧すると、画面が小さいので見づらいというのと、メンターサポートを受ける際に、自分の作業環境を画面共有で見せることができないというデメリットがあります。<br>各種メンターサポートを受ける際はご自身の疑問点を<ul class="list-disc"><li>口頭、文章で説明</li><li>キャプチャをiPhoneに送ってから送信する</li></ul>などで説明せざるを得なく、利便性は悪いと思われます。'
            },
            {
              id: 3,
              q: 'Discordアプリがインストールできません。',
              a: 'ブラウザ版もございますのでお試しください。'
            }
          ]
        },
        {
          id: 5,
          category: '学習の進め方',
          items: [
            {
              id: 1,
              q: '学習はどのようなサイクルで進めますか？',
              a:
                '各章で下記の3ステップを実施いただき、全てをクリアできたら次の章に進むことができます。<br><ol class="list-number"><li>教材を読みながら手元で制作</li><li>各項目の制作課題を実施、メンターに提出してOKをもらう</li><li>章全体の制作課題を実施、メンターに提出してOKをもらう</li></ol>全ての章の学習を終えたら、ポートフォリオ制作に注力していただきます。<br>企画書の添削から作品のクオリティチェックまで、全面的にメンターがサポートします。'
            },
            {
              id: 2,
              q: '勉強にはどのくらいの時間をかければ良いですか？',
              a:
                '教材の学習は目安として1日1時間程度とご案内しておりますが、実際の進捗状況によってご自身で調節して下さい。'
            },
            {
              id: 4,
              q:
                '自分で設定した受講期間内に学習が終わらなかった場合はどうなりますか？',
              a:
                'そのまま予定通りご卒業いただくか、あるいは翌月も延長するかお選びいただくことが可能です。<br>ご卒業の場合は、それまでに履修されたカリキュラムをダウンロードいただけます。延長される場合は、追加分の受講料がかかります。なお、受講期間は最長でも入校から一年間とさせていただいております。'
            },
            {
              id: 5,
              q: '受講期間中、休学は可能ですか？',
              a:
                'マスタープランの場合、在籍期限内(1年間)であれば、柔軟に休学は可能です。<br>マスタープラン以外のプランですと、休学は原則できません。'
            }
          ]
        },
        {
          id: 6,
          category: '就職支援・卒業後',
          items: [
            {
              id: 1,
              q: '卒業後も在学中のDiscordは見られますか？',
              a:
                '受講生用のDiscordへのアクセスは、受講期間中のみとなります。<br>なお卒業後も、卒業生同士で交流いただけるコミュニティを別途ご用意します。'
            },
            {
              id: 2,
              q: '卒業後も教材は見られますか？',
              a:
                '教材のダウンロードは可能です。卒業時に学習を進めていただいた章までがダウンロードの対象範囲となります。<br><br>ただ、マスタープランを６ヶ月以上受講された方の場合、進めた範囲とは関係なく、全てのカリキュラムをダウンロードすることが可能です。'
            },
            {
              id: 3,
              q: '卒業後の案件サポート、就業支援などはありますか？',
              a:
                '就職・転職希望の方はVookキャリアに登録して、スクール卒業生としてサポートを受けられます。<br>サービス自体は他社とそれほど変わりませんが、Vook school生の場合、日々の学習の様子・制作に取り組む様子もキャリアにつなぎこめるので、自己PRでしかアピールできなかった本人の魅力や、素の部分というのを第三者視点でキャリア活動に生かすことができます。<br>Vookキャリアについてはこちらをご覧ください。<br><a href="https://career.vook.vc" target="_blank">https://career.vook.vc</a><br><br>案件紹介・依頼に関しては、本人のレベル感にも大きく左右されるので、"必ずします"というわけではないです。<br>卒業後のコミュニティで案件を紹介するケースもあれば、実力の問題から個別にご案内するケースもございます。'
            },
            {
              id: 4,
              q: '就職支援はいつから受けられますか？',
              a:
                '就職支援ですが、ご希望があれば受講途中からでも可能です。<br>その場合の目途は、マスタープランの場合、4-5ヵ月経ったあたりを想定してます。<br>出来るだけ皆さまの学習様子や力量を把握できた方がスムーズと考えているため、そのあたりで設定をさせていただいております。<br>ただ、最後に作っていただくポートフォリオ作品がご自身の作品集で一番輝く作品になるかと思うので、4-5月経過あたりでエージェントとの面談や資料準備をしていただき、実際の応募は受講修了後をお勧めしたいなと思っております。<br>就職支援についてはケースバイケースのため、一例となります。また、その都度ご相談しつつ進めさせていただく形となります。'
            }
          ]
        },
        {
          id: 7,
          category: 'プランについて',
          items: [
            {
              id: 2,
              q: '受講期間中にプランを変更することは可能ですか？',
              a:
                '翌月分のプランより、プランの変更は可能です。<br>当月分は、予めお申し込みいただいていたプランをご受講いただき、翌月分からプラン変更が適用されます。'
            }
          ]
        },
        {
          id: 8,
          category: '申し込み・入校について',
          items: [
            {
              id: 1,
              q: '入校日はいつですか？',
              a:
                '毎月１日です。年末年始休みの影響で、毎年１月は入校日を変更させていただく場合がございます。'
            },
            {
              id: 2,
              q: '申し込み方法が分かりません。',
              a:
                'こちらのURLから申し込みおよび決済手続きができます。<br>※ご利用にはVookへのログイン、または会員登録（無料）が必要です。<br><a id="school_mgc_registration" href="/registration?course=motion_graphics" class="external_link" target="_blank">https://school.vook.vc/registration?course=motion_graphics</a>'
            },
            {
              id: 3,
              q: '申込期限はいつですか？',
              a:
                '基本的に入校日の１週間前とさせていただいております。「入金が間に合わなさそう」などありましたら、柔軟に対応させていただきますので、お気軽にご相談ください。'
            },
            {
              id: 4,
              q: '支払いはどのような方法でできますか？',
              a: 'クレジットカード支払いにて、お願い申し上げます。'
            },
            {
              id: 5,
              q: '使えるクレジットカードの種類を教えてください。',
              a:
                'Visa、 Mastercard 、 American Express、 JCB、Diners Club、Discoverの６ブランドに対応しています。'
            },
            {
              id: 6,
              q: '分割払いは可能ですか？',
              a:
                '大変申し訳ございません。現状は不可となっております。 ただ、クレジットカードによっては、一括でご決済をいただいた後、ご自身で分割の設定ができるものもございまして、そちらは問題ございません。その際、手数料が発生する場合がございますので、あとから分割ができる機能があるかも含めて、各クレジットカード会社の方へご確認ください。なお、他校様の相場と比較した場合でもカリキュラムに対して適正な価格設定をしておりますので、その点はご安心いただければと思います。'
            },
            {
              id: 7,
              q: '受講料以外に必要な費用はありますか？',
              a:
                '弊社としていただく費用は申込金額以外はございません。なお、PC・ソフトウェア等はご自身でご用意いただいております。'
            },
            {
              id: 8,
              q: '割引はないですか',
              a:
                '原則表示されている価格でのご案内となります。キャンペーン等で一時的に価格を変更する場合がございますが、 不定期となりますのでみなさま基本的には定価でお申し込みを頂いております。 決して安い金額ではございませんが、その分、十分なスキルと経験を身に着けて頂けるカリキュラムと体制を整えておりますので、 将来に必ず役立つ投資になると自信を持ってお伝えさせていただきます。'
            },
            {
              id: 9,
              q: '請求書払いは可能ですか？',
              a:
                '法人負担の場合は対応可能です。掛け払いですと、与信審査がございます。'
            }
          ]
        },
        {
          id: 9,
          category: '受講に必要なもの',
          items: [
            {
              id: 1,
              q: 'どんなPCが必要ですか？',
              a:
                '<strong>【Win】</strong><ul class="list-disc"><li>CPU：3.2GHz以上のクロック数で、かつ8コア以上のものが推奨されています。<br>After Effectsはコア数よりもクロック数の方が重要視されます。</li><li>メモリ：CPUコア1つに対して、4GBを基準に計算します。<br>たとえばCPUが8コアであれば32GBが適切であり、After Effectsを使う上での推奨ラインとなります。予算などの余裕があれば64GBが余力があるのでおすすめです。</li><li>ストレージ：SSDをおすすめしています。<br>After Effectsは大量のキャッシュ（一時保存ファイル）を常時扱いますので、メインのドライブとは別に最低でも500GB程度のSSDがあれば安心です。<br>これは素材用とキャッシュ用で分ける運用が前提となります。</li><li>GPU：最低でも4GB以上のVRAMを持つGPUが必要です。<br>必要とされるスペックは、年々上がっていく傾向にあることを念頭に置いてください。<br><br><strong>【Mac】</strong><br>Macの場合は、最低でも現行の16インチMacBookPro～を最低ラインにして、上記の運用が適切かと思います。<br>Adobeの推奨スペック(以下)を満たすものはMacBook Proのみでした。<ul class="list-disc"><li>CPU：3.2GHz以上（8コア以上推奨）</li><li>メモリ：32GB以上</li><li>ストレージ：64GB以上の空き容量、SSD推奨</li><li>GPU：4GB以上のVRAMを持つもの</li></ul>'
            },
            {
              id: 2,
              q: 'どんなソフトが必要ですか？',
              a:
                'お手数ですが、下記4点のソフトをご自身でご用意ください。<ul class="list-disc"><li>Adobe After Effects</li><li>Adobe Premiere Pro</li><li>Adobe Illustrator</li><li>Adobe Photoshop</li></ul>※3アプリ以上の製品を利用する場合、単体でのご購入よりも、コンプリートプランのほうが割安になりますので、おすすめです。<br>なお、マスタープランで使用するRed Giant Completeは、このカリキュラム自体の受講が任意ですが、ソフトはご自身でご用意いただく必要がございます。'
            },
            {
              id: 3,
              q:
                'After Effects等は、最新のバージョンを用意しておけばよろしいでしょうか?',
              a:
                '現在は最新のバーション「24.4」で学習いただくようお願いしております。<br>当スクールとしては、ゆくゆく安定・安心して仕事をしていただくという観点から過去のバージョンをメインで使用し、安定後にバージョンを上げるなどの対応をおすすめしております。<br>ただ、現在は最新のバージョンが安定しているため、最新のバージョンをご利用いただいてます。<br>学習のために使用いただくAfter Effectsのバージョンに変更がある場合、運営からアナウンスさせていただく形となります。<br>バージョンごとのダウンロードと保持の方法（Adobe公式）はこちらをご覧ください<a href="https://helpx.adobe.com/jp/download-install/using/install-previous-version.html" target="_blank">https://helpx.adobe.com/jp/download-install/using/install-previous-version.html</a>'
            },
            {
              id: 4,
              q: '受講にあたってどのようなスキルが必要ですか？',
              a:
                '映像制作に関するスキルは受講開始後に一から学んでいただけるため、PCの一般的な操作方法を理解していれば問題ありません。'
            }
          ]
        },
        {
          id: 10,
          category: 'その他',
          items: [
            {
              id: 1,
              q:
                '現在HAL名古屋の映像学科に在籍しているのですがその場合でも入学することは可能でしょうか？',
              a:
                'ダブルスクールは問題ありません。すでにご通学されている方のスクールとのスケジュールも加味しながら、学習の見通しを立てさせていただきますので、お気軽にご相談ください。'
            },
            {
              id: 2,
              q: '教育給付金制度は使えますか？',
              a:
                'Vook schoolは教育給付金制度の対象外となっております。ご希望に添えず、大変申し訳ございません。'
            }
          ]
        },
        {
          id: 11,
          category: 'ちょっとコアな質問',
          items: [
            {
              id: 1,
              q:
                'フリーランスのイラストレーターです。今後兼業としてアニメーターやMVクリエイターを目指しているのでマスタープランの受講を希望しているのですがそういった目的での受講は可能でしょうか？',
              a:
                'After Effectsの基礎からモーションを学習しますので、イラストを「パーツごとに動かす」などの知識を得ることができるほか、テキストモーションについてのカリキュラムがありますので、いわゆるリリックビデオ的なモーションを学ぶことができます。<br>アニメーター＝世間一般のジャパニーズアニメの作画という意味では、残念ながらカリキュラムの範囲外となってしまいます。イラストがどういうものか、どういうアニメーションなのか、で部分必要とする知識は細分化していくことになりますが、その知識の礎となるモーショングラフィックス全般の知識を学んでいただけるかと存じます。'
            },
            {
              id: 2,
              q:
                '自前のPCがスペック不足のため、本業（会社支給）で使用しているPCで参加をさせていただこうと思っておりますが可能でしょうか？（スクールとの連絡：自前のMac＝Gmail、実作業：会社のWin）',
              a:
                '差分に関しては問題ございませんが、メールアドレスが異なる点のみ補足をさせていただきます。<br><br>こちら、学習上は特に問題ないのですが、メールアドレスを使用するシーンを今後の連絡手段も含めご説明させていただきます。<br>今後のご連絡ですが、２種類の手段を使用いたします。<br><br><strong>①Discord</strong><ul class="list-disc"><li>メンターとのコミュニケーション</li><li>在校生同士のコミュニケーション</li><li>運営との学習に関する各種連絡</li><li>座談会等のイベント参加など</li></ul><br><strong>②メール</strong><br><ul class="list-disc"><li>カリキュラム閲覧に際したログイン（端末ごと、初回のみ）</li><li>進捗に関するリマインドメール</li><li>Vook schoolや契約に関する各種ご連絡など</li></ul><br>PCが分かれる点に関し、実作業としては全く問題ございません。OSも両方に対応したカリキュラムとなっております。<br>カリキュラム閲覧に際し、初回のみログインの際にメールアドレス宛に数字5桁のピンコードが送付されますので、スマホなど何かしらでピンコードがわかれば特に問題はないかと存じます。<br><br>ただ、メンターとのコミュニケーションにおいて、PCが分かれる場合に注意事項がございます。<br>前提として、同一PCでの一般的なフローが以下の通りです。<ol class="list-number"><li>Discordに記載のカリキュラム閲覧URLを開く</li><li>ブラウザ上で、カリキュラムを閲覧</li><li>AfterEffectsなどで実制作</li><li>作業データを指定のURLを用い、ブラウザ経由でアップロード（厳密には違いますが、こちらで用意したクラウドストレージのフォルダにアップいただくイメージ）</li><li>Discordにてアップしたこと、フィードバックいただきたいことをご連絡（4.にてアップしたURL等は不要です）</li><li>Discordにて通話orテキストにてメンターよりフィードバック</li><ol><br>こちらにおける、6.に関して、通話をする場合は画面共有をしながら質問・フィードバックをいただくことを推奨しております。<br>その際にPCが分かれておりますと画面共有ができないため、円滑なフィードバック等ができない恐れがございます。<br><br>その他、1.～5.に関しては、<ul class="list-disc"><li>URLさえわかればアクセスできるもの</li><li>ピンコードさえわかればアクセスできるもの</li></ul>となっておりますので、両PCで情報が共有できれば特に支障はないかと存じます。<br><br>まとめますと、お聞きした範囲で両PCが横に並んでいる状況（同時に閲覧できる状況）と仮定しますと、以下の切り分けをお勧めいたします。<br><br><strong>・自前のMac</strong><br>→ブラウザ版Discord（各種連絡用）、カリキュラム閲覧<br><br><strong>・会社のWin</strong><br>→Discord（通話時に使用、各種素材のDL用）、実制作<br>※Discordは同一アカウントの同時ログインが可能です'
            }
          ]
        }
      ],
      faq_lists_videographer_online: [
        {
          id: 1,
          category: '',
          items: [
            {
              id: 1,
              q: 'コンテンツの視聴期限はいつまでですか？',
              a:
                '購入日より6ヶ月間（180日間）視聴可能です。期間内は、何度でもご視聴いただけます。'
            },
            {
              id: 2,
              q: 'コース購入後に、返金は申請できますか？',
              a:
                '購入後の返金は、原則受け付けておりません。予めご了承いただきますようお願い申し上げます。'
            },
            {
              id: 3,
              q:
                'コース内で説明している、機材やソフトウェアについて教えてください。',
              a:
                'ミラーレス一眼レフカメラ、レンズ、三脚、ノートパソコン、Adobe Premiere Proについて、を説明しています。'
            },
            {
              id: 4,
              q: 'コンテンツの倍速再生はできますか？',
              a: '1.5倍速・2倍速・0.5倍速での再生が可能です。'
            },
            {
              id: 5,
              q: '本編の続きとなるようなコンテンツはありますか？',
              a:
                'オンライン映像で、続きとなるようなコンテンツは現時点ではありません。<br>より学習したい方は、オフラインでの学習となりますが、月額制 Vook school ビデオグラファーコースでの学習を推奨しています。よりハイレベルな映像制作のノウハウを学びたい方はぜひご検討ください。<br><br>Vook school ビデオグラファーコース詳細は<a href="/videographer">こちら</a>'
            }
          ]
        }
      ]
    }
  },
  mounted() {
    this.setMoreFaq()
  },
  methods: {
    getList() {
      if (this.current === 'videographer') {
        return this.faq_lists_videographer
      } else if (this.current === 'motiongraphics') {
        return this.faq_lists_motiongraphics
      } else if (this.current === 'videographer-online') {
        return this.faq_lists_videographer_online
      }
    },
    // videographer-onlineのFAQ総数が少ないため、Moreボタンは表示しないようにする
    setMoreFaq() {
      if (this.current === 'videographer-online') {
        this.isFaqShow = true
      }
    },
    showMoreFaq() {
      this.isFaqShow = !this.isFaqShow
    },
    showMoreFaqByButton() {
      this.isFaqShow = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~/assets/css/individual/school/school2023.scss';

.faq {
  .l-container {
    @include media(pc) {
      display: flex;
    }
  }
  h2 {
    @include media(pc) {
      width: 300px;
    }
    @include media(sp) {
      margin-bottom: 30px;
    }
  }
  &-body {
    flex: 1;
  }
  &-list {
    .faq-category + .faq-category {
      margin-top: 50px;
    }
    flex: 1;
    position: relative;
    overflow: hidden;
    margin-bottom: 20px;
    max-height: 550px;
    h3 {
      font-size: 24px;
      font-weight: bold;
      @include media(sp) {
        font-size: 20px;
      }
    }
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      pointer-events: none;
      width: 100%;
      height: 50px;
      background: linear-gradient(to bottom, transparent, #fff);
    }
    &.is-active {
      max-height: unset;
      &:after {
        display: none;
      }
    }
  }
  &-more {
    margin-top: 50px;
    text-align: center;
    &-btn {
      position: relative;
      padding-right: 45px !important; //スタイル上書き
      cursor: pointer;
      &:before {
        content: '';
        width: 10px;
        height: 10px;
        border-left: solid 1px #000;
        border-bottom: solid 1px #000;
        position: absolute;
        top: calc(50% - 8px);
        right: 20px;
        transform-origin: center;
        transform: rotate(-45deg);
      }
    }
  }
}
::v-deep {
  .accordion {
    .l-container {
      padding: 0;
    }
    border-bottom: solid 1px #444444;
    &-ttl {
      line-height: 1.5em;
      padding: 20px 50px 20px 0;
      position: relative;
      cursor: pointer;
      @include media(sp) {
        line-height: 1.5;
        padding: 10px 30px 10px 0;
      }
      &:before {
        content: '';
        position: absolute;
        width: 25px;
        height: 25px;
        border-radius: 25px;
        border: solid 1px #666;
        right: 10px;
        top: calc(50% - 12.5px);
        @include media(sp) {
          right: 0px;
        }
      }
      &:after {
        content: '';
        position: absolute;
        width: 9px;
        height: 9px;
        border-left: solid 1px #666;
        border-bottom: solid 1px #666;
        right: calc(10px + (25px - 9px) / 2);
        top: 50%;
        transform: translateY(-70%) rotate(-45deg);
        transform-origin: center center;
        transition: all 0.3s;
        @include media(sp) {
          right: calc((25px - 9px) / 2);
        }
      }
      .content {
        font-weight: bold;
        font-size: 16px;
      }
    }
    &-body {
      padding: 0;
      height: 0;
      opacity: 0;
      overflow: hidden;
      transition: all 0.3s;
      .txt {
        line-height: 1.8;
      }
      h3 {
        @include media(sp) {
          margin-bottom: 30px;
        }
      }
      strong {
        font-weight: bold;
      }
      .faq-mentor-chat {
        li + li {
          margin-top: 10px;
        }
      }
      .list-disc {
        list-style: disc;
        margin: 10px 0;
        li {
          margin-left: 1em;
        }
      }
      .list-number {
        list-style: decimal;
        margin: 10px 0;
        li {
          margin-left: 1.5em;
        }
      }
    }
    &.is-open {
      .accordion-ttl {
        &:after {
          transform: translateY(-30%) rotate(135deg);
        }
      }
      .accordion-body {
        padding: 0px 0 20px;
        height: auto;
        opacity: 1;
      }
    }
  }
}
</style>
